import { useEffect } from "react";
import { QueryProvider } from "@/providers/QueryProvider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { TourProvider } from "@/contexts/TourContext";
import { useAuth } from "@/providers/AuthProvider";
import { BryntumThemeProvider } from "@/contexts/BryntumThemeContext";
import { setApiUrl } from "@/lib/api-config";
import { configureAuth } from "@/lib/auth-fetch";
import App from "@/App";

interface AppContainerProps {
  settings?: {
    apiUrl?: string;
    clientId?: string;
    defaultUrl?: string;
    identityUrl?: string;
    redirectUri?: string;
    scope?: string;
    workspaceUrl?: string;
  };
}

export default function AppContainer({ settings }: AppContainerProps = {}): React.ReactElement {
  const { getAccessToken, instanceId, evoOrganisationId } = useAuth();

  // Set apiUrl synchronously before render to ensure it's available for API calls
  if (settings?.apiUrl) {
    console.log('[AppContainer] Setting API URL to:', settings.apiUrl);
    setApiUrl(settings.apiUrl);
  } else {
    console.log('[AppContainer] No apiUrl in settings, not calling setApiUrl');
  }

  // Set apiUrl synchronously before render to ensure it's available for API calls
  if (settings?.apiUrl) {
    setApiUrl(settings.apiUrl);
  }

  useEffect(() => {
    configureAuth({ getAccessToken, instanceId, evoOrganisationId });
  }, [getAccessToken, instanceId, evoOrganisationId]);

  return (
    <QueryProvider>
      <TooltipProvider>
        <BryntumThemeProvider>
          <TourProvider>
            <Toaster richColors duration={5000} closeButton />
            <App />
          </TourProvider>
        </BryntumThemeProvider>
      </TooltipProvider>
    </QueryProvider>
  );
}
